import React from 'react'
import {FirebaseMessageListItem, MessageMode, ObjectState} from 'types'
import GiftShopMessageListHome from './GiftShopMessageListHome'
import GiftShopMessageListNew from './GiftShopMessageListNew'

export interface GiftShopMessageListProps {
  stateMode: ObjectState<MessageMode>
  stateSelectedMessagesForkygram: ObjectState<string[]>
  stateSelectedMessagesGS: ObjectState<string[]>
  data: FirebaseMessageListItem[]
  initialize: boolean
}

export default function GiftShopMessageList({
  stateMode,
  stateSelectedMessagesForkygram,
  stateSelectedMessagesGS,
  data,
  initialize,
}: GiftShopMessageListProps) {
  const [mode] = stateMode
  return mode === 'new-message' ? (
    <GiftShopMessageListNew />
  ) : (
    <GiftShopMessageListHome
      stateMode={stateMode}
      stateSelectedMessagesForkygram={stateSelectedMessagesForkygram}
      stateSelectedMessagesGS={stateSelectedMessagesGS}
      data={data}
      initialize={initialize}
    />
  )
}
